import React from 'react'
import { get, post } from 'client/utils/api-routes.util'
import { pixelFactoryContext } from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import useChatRoom from 'shared/hooks/useChatRoom'
import styled from 'styled-components'

import { IpixelFactoryContext } from '../../../../../../../../../decl'
import Wimage from '../../../common/assets/images/whatsapp.png'
import Icon from '../../../common/components/icons'
import Splash from '../../splash/index'
import Sidebar from '../components/sidebar/Sidebar'
import UnSelectedChatPage from '../unselected-page/index'

import Footer from './components/footer'
import Header from './components/header'
import MessagesList from './components/messages-list'

export default function ChatRoomPage() {
  const { showFailure } =
    React.useContext<IpixelFactoryContext>(pixelFactoryContext)
  const [currentChat, setCurrentChat] = React.useState()
  const [currentChatDetails, setCurrentChatDetails] = React.useState([])
  const [sideBarData, setSideBarData] = React.useState([])
  const [isDataAvailable, setIsDataAvailable] = React.useState(false)
  const [activeNumber, setActiveNumber] = React.useState(0)

  const handleGetActiveNumber = (aNumber) => {
    setActiveNumber(aNumber)
  }
  const handleCallback = (childData) => {
    const messageDetails = currentChatDetails[0]
    post('/communication/number/wa/send-message', {
      message: childData,
      customer_number: messageDetails.customer_number,
    }).subscribe((res: AjaxResponse<any>) => {
      if (res.response.error) {
        showFailure('Failed to send message')
      }
    })

    const newMessage = {
      id: messageDetails.id,
      ems_customer_id: messageDetails.ems_customer_id,
      business_number_id: messageDetails.business_number_id,
      business_number: messageDetails.business_number,
      customer_number: messageDetails.customer_number,
      message_type: 'send',
      message: childData,
      created_at: new Date().toISOString(),
      message_id: null,
      reaction: null,
      sent_at: null,
      delivered_at: null,
      read_at: null,
      received_at: null,
      failed_at: null,
      failed_reason: null,
      updated_at: null,
      pixelone_read_at: null,
    }
    setCurrentChatDetails([...currentChatDetails, newMessage])
    setShouldScrollToBottom(true)
  }

  const {
    handleMenuOpen,
    handleShowIcon,
    isShowIcon,
    setShouldScrollToBottom,
    shouldScrollToBottom,
  } = useChatRoom()

  React.useEffect(() => {
    get('/communication/wa/contacts-messages/summary').subscribe((res) => {
      if (res.response) {
        if (res.response?.data) {
          setSideBarData(res.response.data)
          setIsDataAvailable(true)
        } else if (res.response.error) {
          setIsDataAvailable(null)
        }
      }
    })
  }, [])

  React.useEffect(() => {
    if (currentChat?.customer_number)
      get(
        `/communication/wa/contacts-message/details?customer_number=${currentChat?.customer_number}`,
      ).subscribe((res) => {
        if (res.response && res.response.data) {
          setCurrentChatDetails(res.response.data)
        }
      })
  }, [currentChat])

  return !isDataAvailable ? (
    isDataAvailable === null ? (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <img width={'50%'} src={Wimage} />
        <div>
          Please configure your WhatsApp settings to use this feature. Go to
          your account settings to complete the configuration.
        </div>
      </div>
    ) : (
      <div
        style={{
          height: '100vh',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Splash progress={isDataAvailable ? 100 : 0} />
      </div>
    )
  ) : (
    <Container
      style={{
        maxWidth: '1450px',
        background: '#DDDBD1',
        width: '100%',
        boxShadow:
          ' 0 1px 1px 0 rgba(0, 0, 0, 0.06), 0 2px 5px 0 rgba(0, 0, 0, 0.2) ',
      }}
    >
      <>
        <Sidebar
          activeNumber={activeNumber}
          setCurrentChat={setCurrentChat}
          sideBarData={sideBarData}
        />
        {currentChatDetails.length <= 0 && <UnSelectedChatPage />}
        {currentChatDetails.length > 0 && (
          <Body>
            <Background />
            <Header
              title={currentChatDetails[0]?.customer_number}
              image={''}
              subTitle={'Online'}
              onSearchClick={() => handleMenuOpen('search')}
              onProfileClick={() => handleMenuOpen('profile')}
            />
            <MessagesList
              onShowBottomIcon={handleShowIcon}
              shouldScrollToBottom={shouldScrollToBottom}
              handleGetActiveNumber={handleGetActiveNumber}
              messages={currentChatDetails || {}}
            />
            <FooterContainer style={{ background: 'rgb(237, 237, 237)' }}>
              {isShowIcon && (
                <ScrollButton
                  style={{ border: 'none', color: '#989898' }}
                  onClick={() => setShouldScrollToBottom(true)}
                >
                  <Icon id="downArrow" />
                </ScrollButton>
              )}
              <Footer parentCallback={handleCallback} />
            </FooterContainer>
          </Body>
        )}
      </>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  background: 'rgb(237, 237, 237)';
  position: relative;
  max-height: 100vh;
`

const Body = styled.div`
  min-width: 300px;
  flex: 40%;
  border-right: 1px solid '#dadada';
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
`

const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  opacity: 0.05;
  z-index: 1;
  background: url('/bg-chat-room.jpg') '#e4dcd4';
`

const FooterContainer = styled.div`
  background: 'rgb(237, 237, 237)';
  position: relative;
  z-index: 100;
`

const ScrollButton = styled.button`
  position: absolute;
  right: 15px;
  bottom: 80px;
  width: 42px;
  height: 42px;
  z-index: -1;
  border-radius: 50%;
  color: '#00000099';
  display: flex;
  justify-content: center;
  align-items: center;
  background: 'white';
  box-shadow: '0 1px 1px 0 rgba(0, 0, 0, 0.06), 0 2px 5px 0 rgba(0, 0, 0, 0.2)';
  z-index: 10;
`
